import { Header } from './Header'
import { Footer } from './Footer'

export function PageShell({ children }) {
  return (
    <>
      <a className="skip-link" href="#main-content">İçeriğe geç</a>
      <Header />
      <main id="main-content">{children}</main>
      <Footer />
    </>
  )
}
